export default {
  getDataTransferObject(state) {
    return state.dataTransferObject
  }
}
